/* istanbul ignore file */
import * as rax from 'retry-axios';
import axios from "axios";
import GlobalConstants from '../projects_module/constants';


const axiosObj = axios.create({
  isRquireGSIDHeader: true,
  isRequireOa2Header: true
});
// retryCounter max value for 401 errors calls
const retryCounterMaxValue = 4;

axiosObj.interceptors.request.use(function (config) {
  function buildHeaders(noodle){
    try{
      //Merge the overiden headers and form the final headers.
      config.headers = Object.assign({

        Noodle: noodle || photoOrg.Util.guid(),
        'content-type': "application/json"
      },config.headers)
      if(config.isRequireOa2Header){
        // Route through zuulAuthClient.getAuthHeaderValue() (same choke point ajax_caller.js
        // and AjaxHelper.ts already use) so Zuul mode sends "Bearer <idToken>" instead of the
        // legacy "OAuth <oa2>" - this axios instance (used by the Projects React module) was
        // never wired up during the Zuul migration, which is why Projects API calls kept
        // showing "OAuth" instead of "Bearer" even with Zuul enabled.
        var oa2 = photoOrg.oauthFetcher.getOa2();
        var authHeaderValue = photoOrg.getAuthHeaderValue(oa2);
        if(authHeaderValue){
          config.headers['Authorization'] = authHeaderValue;
        }
        var acctIdHeaderValue = photoOrg.getAcctIdHeaderValue();
        if(acctIdHeaderValue){
          config.headers['AcctId'] = acctIdHeaderValue;
        }
       }
      if(config.isRquireGSIDHeader){
        config.headers['GSID'] = photoOrg.oauthFetcher.getGsid();
      }
    }catch(e){}
  }

  // Wait for the expired-token refresh (if one is actually needed) to complete before
  // building headers and firing the request. checkAndGetRefreshToken only performs a
  // real refresh when the token is actually expired; otherwise it invokes the callback
  // immediately with no refresh call.
  return new Promise(function(resolve){
    try{
      var noodle = photoOrg.Util.guid();
      photoOrg.oauthFetcher.checkAndGetRefreshToken(noodle, function(){
        buildHeaders(noodle);
        resolve(config);
      }, true);
    }catch(e){
      resolve(config);
    }
  });
}, function (error) {
      return Promise.reject(error);
});

axiosObj.interceptors.response.use(undefined, err => {
  const error = err.response;

  //when refresh token misses in global session, we are redirecting to login page when 401 errors calls exceeds or equal to limit 4 
  if(error.config.retryCounter >= retryCounterMaxValue){
    return photoOrg.Util.redirectToLoginPageWithoutNextParam();
  }
  // if error is 401 
  if (error.status===401) {
  // request for a new token
  return new Promise((resolve, reject) => {
    // fetchToken is async - the retry must only be sent once this callback actually runs
    // (after the token has been refreshed and the header rebuilt), not immediately after
    // calling fetchToken. Firing it outside this callback would race the refresh and send
    // the retry with the still-expired header; it would also leave this promise permanently
    // unresolved on success, since axiosObj(error.config)'s result was never wired to resolve.
    photoOrg.oauthFetcher.fetchToken(err.config.headers.Noodle, function(status){
      // A failing zuul-mode refresh also invokes this callback (with a "failure-..." status)
      // in addition to the failureCallback (reject) below, so every caller's continuation is
      // released either way - skip retrying here since reject has already settled this promise.
      if (status && ("" + status).indexOf('failure') === 0) {
        return;
      }
      // update the error config with new token - fetchToken() above already refreshed the
      // Zuul idToken internally when Zuul is enabled (see oauthFetcher.js), so route the
      // rebuilt header through the same Bearer/OAuth decision as the initial request.
      var oa2 = photoOrg.oauthFetcher.getOa2();
      error.config.headers.Authorization = photoOrg.getAuthHeaderValue(oa2);
      var acctIdHeaderValue = photoOrg.getAcctIdHeaderValue();
      if(acctIdHeaderValue){
        error.config.headers.AcctId = acctIdHeaderValue;
      }

      if(error.config.retryCounter == undefined){
        error.config.retryCounter =0;
      }
      else{
        error.config.retryCounter +=1;
      }

      resolve(axiosObj(error.config));
    } , true, false, reject);
  });
 } 
});
axiosObj.defaults.raxConfig = {
  instance: axiosObj,
  retry: 2, 
  // Milliseconds to delay at first.  Defaults to 100. Only considered when backoffType is 'static' 
  retryDelay: 100, 
  shouldRetry: err => {    
    const cfg = rax.getConfig(err);
    const noodle = err.response.data.Noodle || err.config.headers.Noodle;
    const errorThrown = err.response.statusText;
    const reqUrl = err.config.url;
    const statusCode = err.response.status;
    let requestDetails = Object.assign({},err.config);
    let responseDetails = err.request.responseText
    requestDetails = photoOrg.Util.maskpII(requestDetails);//Removing The Auhorization header before logging the request details.
    requestDetails = JSON.stringify(requestDetails).replace(/"/g,"'");
    
    // if(window.btoa){
    //     responseDetails = window.btoa(JSON.stringify(responseDetails))
    // }else{
    responseDetails = photoOrg.Util.maskpII(responseDetails);
    //}
    responseDetails = responseDetails? JSON.stringify(responseDetails).replace(/"/g,"'") : "";
    var log = {
      description: "API call Failed",
      httpStatusCode: statusCode,
      Noodle: noodle,
      iterationCount: cfg.currentRetryAttempt,
      errorThrown: errorThrown,
      url: reqUrl,
      quickLogger: true,
      requestDetails: requestDetails,
      responseDetails: responseDetails
    }

    //const {open, close, openModal, closeModal} = PortalActions();    
    if(cfg.currentRetryAttempt === 2){
      const customEvent = new CustomEvent(GlobalConstants.ERROR_NOTIFY, { detail: { noodle: noodle, errorId:err.response.data.errorId
        , show:true, errorMessage: err.response.data.errorCode
      } });
      document.dispatchEvent(customEvent); 
      photoOrg.clientLogger.error(log);

    }else if (err.response && err.response.status === 401){
      log.errorCode = "InvalidOauth2Token";
      photoOrg.clientLogger.warn(log);
      return false;
    } else if (cfg.currentRetryAttempt === 0 || (err.response && (err.response.status === 0 || err.response.status === 404))){
      err.config.url += err.config.url.indexOf("?") > 0 ? "&" : "?";
      err.config.url +=  "Noodle=" + noodle;
      if(err.response){
        if(err.response.status === 0){
          log.errorCode = "HTTPStatus-0";
        }else if(err.response.status === 404){
          log.errorCode = "NotFound";
        }
      }
      photoOrg.clientLogger.warn(log);
      return true;
    } else if(cfg.currentRetryAttempt === 1){
      err.config.url = photoOrg.Util.convertToBaseDomainHostNameUrl(err.config.url)
      photoOrg.clientLogger.warn(log);
      return true;
    }
    return false;
  },
  onRetryAttempt: err => {
    const cfg = rax.getConfig(err);
    console.log(`Retry attempt #${cfg.currentRetryAttempt}`);
  }
};
const interceptorId = rax.attach(axiosObj);



// axiosObj.interceptors.response.use(function (response) {
//     // Any status code that lie within the range of 2xx cause this function to trigger
//     // Do something with response data
//     return response;
//   }, function (error) {
//     // Any status codes that falls outside the range of 2xx cause this function to trigger
//     // Do something with response error
//     debugger;
//     return Promise.reject(error);
//   });
export default axiosObj;